export const TRANSLATIONS: Object = {
  'global#no_connection': 'Nessuna connessione con il server, impossibile completare l\'operazione',
  'global#disconneced': 'Disconnesso',
  'global#lost_focus': 'Hai perso il focus. Clicca qui per tornare al questionario',
  'global#lang_en': 'English',
  'global#lang_it': 'Italiano',
  'global#born': 'Nato il',
  'global#in': 'a',
  'global#feedback': 'Lascia una tua impressione',
  'global#results': 'Risultati',
  'global#end': 'Termina',
  'global#total_questions': 'Domande',
  'global#right_answers': 'Risposte esatte',
  'global#wrong_answers': 'Risposte sbagliate',
  'global#null_answers': 'Risposte nulle',
  'global#section_points': 'Punteggio della sezione',

  'login#email_label': 'Login',
  'login#email_placeholder': 'Inserisci il tuo utente',
  'login#password_label': 'Password',
  'login#password_placeholder': 'Inserisci la tua password',
  'login#confirm': 'Login',
  'login#title': 'Login test CISIA',
  'login#sub_title': 'Inserisci le tue credenziali per procedere',
  'login#full_screen_exit': 'Operazione interrotta',
  'login#connection_error_line0': 'Non è stato possibile stabilire la connessione con il server.',
  'login#connection_error_line1': 'Ti preghiamo di riprovare tra qualche minuto.',
  'login#timeout': 'Timeout',
  'login#show_password': 'mostra password',
  'login#hide_password': 'nascondi password',

  'modal#confirm_label': 'Confermo che:',
  'modal#insert_code_label': 'Inserisci il codice:',
  'modal#no_connection': 'Al momento non è presente una connessione con il server.',
  'modal#termiate_title': 'Tempo terminato',
  'modal#termiate_description': 'Puoi continuare passando alla sezione',
  'modal#termiate_submit': 'Continua',
  'modal#terminate_request_title': 'Il tempo a tua disposizione è terminato',
  'modal#terminate_request_description': 'Il test è concluso, prosegui per salvare e visualizzare il risultato',
  'modal#terminate_request_submit': 'Salva',
  'modal#terminate_request_check': 'visualizzerò il risultato finale',
  'modal#terminate_request_user_title': 'Attenzione, procedura per concludere il test',
  'modal#terminate_request_user_submit': 'Termina',
  'modal#terminate_request_user_check_1': 'voglio concludere il test',
  'modal#terminate_request_user_check_2': 'visualizzerò il risultato finale',
  'modal#change_section_title': 'Vuoi passare alla sezione',
  'modal#change_section_submit': 'Continua',
  'modal#change_section_description_1': 'Passando alla sezione',
  'modal#change_section_description_2': 'non potrai più tornare alla sezione corrente',
  'modal#change_section_description_3': 'e perderai il tempo non utilizzato.',
  'modal#change_section_freeInsert': '',
  'modal#change_section_check_1': 'voglio passare alla sezione',
  'modal#change_section_check_2': 'perderò il tempo non utilizzato',
  'modal#insert_code': 'Inserisci il codice',
  'modal#cancel': 'Annulla',
  'modal#confirm': 'Conferma',
  'modal#refresh_title': 'Attendere',
  'modal#refresh_description': 'Caricamento in corso...',
  'modal#local_id': 'Local ID',
  'modal#local_ip': 'Local IP',
  'modal#sync_status_pending': 'Salvataggio sezione in corso',
  'modal#sync_status_ko': 'Salvataggio sezione non riuscito',
  'modal#confirm_audio_start_title': 'Avvio audio',
  'modal#confirm_audio_start_description': 'Ti ricordiamo che non potrai interrompere la riproduzione una volta avviata.<br />Confermi l\'avvio della riproduzione audio?',

  'title#test_evaluation': 'Valutazione prova',
  'title#answer_correct': 'Risposta corretta',
  'title#answer_wrong': 'Risposta sbagliata',
  'title#answer_null': 'Risposta nulla',

  'console#title': 'Console di verifica',
  'console#close': 'Chiudi',
  'console#server_ok': 'Connesso con il server',
  'console#internet_ok': 'Blocco accesso a internet',
  'console#canvas_ok': 'Supporto canvas',
  'console#html5_ok': 'Supporto HTML5',
  'console#audio_ok': 'Supporto audio',
  'console#storage_ok': 'Supporto memoria locale',
  'console#websockets_ok': 'Supporto websockets',
  'console#ping_cisia_ok': 'Ping server cisia',
  'console#speed_test': 'Test velocità',
  'console#send_log': 'Invia resoconto errori',
  'console#duplicate_login_title': 'Attenzione!',
  'console#duplicate_login_description': '<div class="modal-message-center">E\' stato riscontrato accesso simultaneo, <br />in questa finestra non sarà più possibile proseguire con il test<br />Contattare il Commissario d\'aula.</div>',

  'wait#welcome_greetings_line_2a': 'Verificare che i dati anagrafici sopra riportati siano corretti,\n',
  'wait#welcome_greetings_line_2b': 'in caso contrario avvisare la commissione d\'esame.',
  'wait#welcome_greetings_line_2c': 'Per iniziare il test premere sul pulsante "Inizia".',
  'wait#welcome_greetings_line_tr_2a': 'Tra qualche istante sarà possibile iniziare il test.',
  'wait#welcome_greetings_line_2a_res': 'E\' stato recuperato l\'ultimo salvataggio avvenuto con successo.',
  'wait#welcome_greetings_line_2_res': 'Per continuare il test premi sul pulsante "Riprendi"',
  'wait#welcome_greetings_line_2_ris': 'per visualizzare i risultati premi sul pulsante "Risultati"',
  'wait#welcome_greetings_submit': 'Inizia',
  'wait#welcome_greetings_submit_res': 'Riprendi',
  'wait#welcome_greetings_submit_ris': 'Risultati',
  'wait#welcome_greetings_submit_section_loading': 'Caricamento in corso...',
  'wait#welcome_greetings_name': 'Nominativo',
  'wait#welcome_greetings_birthday': 'Data di nascita',
  'wait#welcome_greetings_birth_place': 'Luogo di nascita',
  'wait#welcome_greetings_cod_fisc': 'Cod. Fis',
  'wait#welcome_line_1': 'Avvia l\'applicazione e non uscire dal fullscreen',
  'wait#welcome_line_2': 'dopo aver effettuato il login',
  'wait#welcome_submit': 'Avvia',
  'wait#nb_intro': 'Nota bene:',
  'wait#nb_description': 'la pressione del tasto \'esc\' manderà in blocco il test',
  'wait#restore_test_line_1': 'Hai',
  'wait#restore_test_line_2': 'secondi per riprendere il test',
  'wait#restore_test_without_count': 'Torna in fullscreen immediatamente, il tempo sta scorrendo',
  'wait#restore_submit': 'Torna in fullscreen',
  'wait#test_locked': 'Test bloccato: informare il responsabile d\'aula',
  'wait#test_section_error': 'Attenzione è stato rilevato un problema bloccante, non è stato possibile caricare la sezione successiva, segnali il problema al commissario d\'aula.',
  'wait#back_to_login': 'Torna al login',
  'wait#socket_disconnected': 'Server disconnesso',

  'survey#domanda': 'Domanda',
  'survey#domande': 'Domande',
  'survey#domanda_wrong': '(sbagliata)',
  'survey#domanda_empty': '(nulla)',
  'survey#testo_comprensione': 'Testo di comprensione',
  'survey#timer_label': 'Tempo rimanente',
  'survey#wrong_code_on_terminate': 'Codice errato',
  'survey#select_answer': 'Seleziona una risposta',
  'survey#deselect_answer': 'Nessuna risposta',

  'report#back_to_survey_1': 'Clicca qui per vedere le domande',
  'report#back_to_survey_2': ' a cui non hai risposto o a cui hai risposto in modo errato',
  'report#point_label': 'Punteggio totale: ',

  'help#attenzione': 'Attenzione',
  'help#box_orange_line_0': 'Durante la visualizzazione di questo help',
  'help#box_orange_line_1': 'NON',
  'help#box_orange_line_2': 'viene fermato lo scorrere del tempo a disposizione per terminare la sezione corrente',
  'help#box_parag_0': 'Nel corso del test, all\'interno di una sezione, è possibile scorrere avanti e indietro le domande in modo da ricontrollare le risposte date. Per annullare una risposta data basta premere sulla risposta stessa.',
  'help#box_parag_1_line_0': 'In qualsiasi momento è possibile premere il pulsante',
  'help#box_parag_1_line_1': '"Termina"',
  'help#box_parag_1_line_2': ', premendo il quale si interrompe il test e si passa alla pagina dei risultati. Il test è inoltre interrotto in maniera automatica allo scadere del tempo concesso.',
  'help#box_parag_2': 'Passando da una sezione alla successiva non è possibile tornare indietro alla sezione precedente.',
  'help#valutazione': 'Valutazione',
  'help#box_parag_3_line_0': 'Il risultato del TOLC è calcolato assegnando 1 punto per le risposte esatte, 0 punti per le risposte non date e una penalizzazione di 0,25 punti per le risposte errate. ',
  'help#box_parag_3_line_1': 'Nella la valutazione della conoscenza della lingua Inglese non c\'è penalizzazione per le risposte errate, il punteggio è calcolato assegnando 1 punto per le risposte esatte e 0 punti per le risposte non date o errate.',
  'help#sezioni': 'Sezioni',
  'help#image_0': 'Indica la sezione attualmente visualizzata',
  'help#image_1': 'Indica la sezione successiva',
  'help#image_2': 'Indica una sezione non selezionabile',
  'help#quesiti': 'Quesiti',
  'help#image_3': 'Indica il quesito attualmente visualizzato',
  'help#image_4': 'Indica un quesito a cui si è già risposto',
  'help#image_5': 'Indica un quesito a cui non si è risposto',
  'help#image_6': 'Indica una pagina con testo',
  'help#image_7': 'Frecce per scorrere al quesito precedente e successivo',
  'help#altri_strumenti': 'Altri strumenti',
  'help#altri_strumenti_button_0': 'Questo pulsante permette di interrompere il test e passare alla pagina dei risultati.',
  'help#altri_strumenti_button_1': 'Visualizza questa pagina di',
  'help#box_parag_4': 'Per modificare il livello di zoom della pagina utilizzare i tasti comando (CTRL o CMD) in combinazione con il "tasto +"" o "il tasto -", rispettivamente per aumentare e diminuire lo zoom.',
  'help#timer_image': 'Il timer indica i minuti e i secondi rimanenti per la sezione corrente.',
  'help#audio_player': 'La traccia audio si avvia tramite il pulsante play ed è possibile aumentare o diminuire il volume tramite il pulsante a fianco. Non è possibile interrompere la traccia, una volta avviata: è necessario ascoltarla fino alla conclusione.'
};



// WEBPACK FOOTER //
// ./src/app/constants/translations/it.ts